import { downloadTexts } from '@constants/general'

export const colorDict = {
  'DZ BANK': 'rgb(255,102,0)',
  LBBW: 'rgb(18,50,80)',
  DekaBank: 'rgb(222,0,46)',
  'Société Générale': 'rgb(0,0,0)',
  'Deutsche Bank': 'rgb(0,24,168)',
  UniCredit: 'rgb(255,0,0)',
  'BNP Paribas': 'rgb(0,106,78)',
  'Goldman Sachs': 'rgb(107,150,195)',
  Vontobel: 'rgb(65,65,65)',
  UBS: 'rgb(230,1,0)',
  Barclays: 'rgb(0,174,239)',
  HSBC: 'rgb(219,0,17)',
  'Morgan Stanley': 'rgb(35,108,166)',
  Citi: 'rgb(37,91,227)',
  'J.P. Morgan': 'rgb(0,0,0)',
  'Börse Stuttgart': 'rgb(101,67,250)',
  'Börse Frankfurt': 'rgb(180,190,58)',
  'Börse gettex': 'rgb(227,10,24)',

  Anlageprodukte: 'rgb(13,138,137)',
  'Investment products': 'rgb(13,138,137)',

  Hebelprodukte: 'rgb(69,33,68)',
  'Leverage products': 'rgb(69,33,68)',

  Gesamt: 'rgb(87,120,169)',
  Total: 'rgb(87,120,169)',

  'SRI-1': 'rgb(123,152,42)',
  'SRI-2': 'rgb(188,182,10)',
  'SRI-3': 'rgb(232, 200, 53)',
  'SRI-4': 'rgb(249,175,21)',
  'SRI-5': 'rgb(237,109,11)',
  'SRI-6': 'rgb(212,72,72)',
  'SRI-7': 'rgb(171,21,18)'
}

export const categoryWeightDict = {
  de: {
    'Festzins- und Stufenzinsanleihen': 3,
    'Strukturierte Anleihen': 3,
    'Kapitalschutz-Zertifikate': 3,
    'Bonitätsabhängige Schuldverschreibungen': 2,
    'Express-Zertifikate': 2,
    Aktienanleihen: 2,
    'Discount-Zertifikate': 2,
    'Bonus-Zertifikate': 2,
    'Index- und Partizipationszertifikate': 2,
    'Weitere Anlageprodukte ohne Kapitalschutz': 2,
    Optionsscheine: 1,
    'Faktor-Optionsscheine': 1,
    'Knock-out-Optionsscheine': 1,
    'Weitere Hebelprodukte': 1
  },
  en: {
    'Fixed-Rate and Step-Up Bonds': 3,
    'Capital Protection Products with Coupon': 3,
    'Uncapped Capital Protection Products': 3,
    'Credit-Linked Notes': 2,
    'Express Certificates': 2,
    'Reverse Convertibles': 2,
    'Discount Certificates': 2,
    'Bonus Certificates': 2,
    'Tracker Certificates': 2,
    'Other investment products without capital protection': 2,
    Warrants: 1,
    'Constant Leverage Warrants': 1,
    'Knock-Out Warrants': 1,
    'Other Leveraged Products': 1
  }
}

export const categoryDict = {
  de: {
    'Festzins- und Stufenzinsanleihen': 'Kapitalschutz',
    'Strukturierte Anleihen': 'Kapitalschutz',
    'Kapitalschutz-Zertifikate': 'Kapitalschutz',
    'Bonitätsabhängige Schuldverschreibungen': 'Ohne Kapitalschutz',
    'Express-Zertifikate': 'Ohne Kapitalschutz',
    Aktienanleihen: 'Ohne Kapitalschutz',
    'Discount-Zertifikate': 'Ohne Kapitalschutz',
    'Bonus-Zertifikate': 'Ohne Kapitalschutz',
    'Index- und Partizipationszertifikate': 'Ohne Kapitalschutz',
    'Weitere Anlageprodukte ohne Kapitalschutz': 'Ohne Kapitalschutz',
    Optionsscheine: 'Hebel',
    'Faktor-Optionsscheine': 'Hebel',
    'Knock-out-Optionsscheine': 'Hebel',
    'Weitere Hebelprodukte': 'Hebel'
  },
  en: {
    'Fixed-Rate and Step-Up Bonds': 'Kapitalschutz',
    'Capital Protection Products with Coupon': 'Kapitalschutz',
    'Uncapped Capital Protection Products': 'Kapitalschutz',
    'Credit-Linked Notes': 'Ohne Kapitalschutz',
    'Express Certificates': 'Ohne Kapitalschutz',
    'Reverse Convertibles': 'Ohne Kapitalschutz',
    'Discount Certificates': 'Ohne Kapitalschutz',
    'Bonus Certificates': 'Ohne Kapitalschutz',
    'Tracker Certificates': 'Ohne Kapitalschutz',
    'Other investment products without capital protection':
      'Ohne Kapitalschutz',
    Warrants: 'Hebel',
    'Constant Leverage Warrants': 'Hebel',
    'Knock-Out Warrants': 'Hebel',
    'Other leverage products': 'Hebel'
  }
}

export const categoryColorDict = {
  Kapitalschutz: { color: 'rgb(87,120,169)', min: 0.15, max: 1 },
  'Ohne Kapitalschutz': { color: 'rgb(13,138,137)', min: 0.15, max: 1 },
  Hebel: { color: 'rgb(69,33,68)', min: 0.15, max: 1 }
}

const abbrevMap = {
  'DZ BANK': 'DZ',
  DekaBank: 'Deka',
  'Société Générale': 'SG',
  'Deutsche Bank': 'DtBank',
  UniCredit: 'UniC',
  'BNP Paribas': 'BNP',
  'Goldman Sachs': 'GS',
  Vontobel: 'Vont',
  Barclays: 'Barc',
  'Morgan Stanley': 'MS',
  'J.P. Morgan': 'JPM',
  'Börse Stuttgart': 'STG',
  'Börse Frankfurt': 'FRA',
  'Börse gettex': 'GTX',
  Anlageprodukte: 'Anlage',
  Hebelprodukte: 'Hebel',
  'Festzins- und Stufenzinsanleihen': 'ZinsAnl',
  'Strukturierte Anleihen': 'StruktAnl',
  'Kapitalschutz-Zertifikate': 'KapSchutz',
  'Bonitätsabhängige Schuldverschreibungen': 'BoniSV',
  'Express-Zertifikate': 'Express',
  Aktienanleihen: 'AktAnl',
  'Discount-Zertifikate': 'Discount',
  'Bonus-Zertifikate': 'Bonus',
  'Index- und Partizipationszertifikate': 'Ind.Zert.',
  'Weitere Anlageprodukte ohne Kapitalschutz': 'WeitereAnlage',
  Optionsscheine: 'Optionss',
  'Faktor-Optionsscheine': 'Faktor',
  'Knock-out-Optionsscheine': 'KnockOut',
  'Weitere Hebelprodukte': 'WeitereHebel',
  'Anleihen (ohne Basiswert)': 'Anleihe(keinBW)',
  'Anleihen (mit Referenzschuldner)': 'Anleihe(Ref.Sch.)',
  Produktklassen: 'ProdKlassen',
  'Anlageprodukte mit 100% Kapitalschutz': 'AnlageMitKapSch',
  'Anlageprodukte ohne Kapitalschutz': 'AnlageOhneKapSch',
  'Börsenumsätze nach Börsenplätzen': 'Börsenplätze',
  'Marktanteile nach Börsenumsätzen': 'Marktanteile',
  'Börsenumsätze nach Produktklassen': 'Produktklassen',
  'Börsenumsätze nach Produktkategorien': 'Produktkategorien',
  'Börsenumsätze nach Basiswerten': 'Basiswerte',
  en: {},
  de: {}
}

export function getAbbrev(name = '', locale) {
  const trimmedName = name.trim()
  if (locale && abbrevMap[locale]?.[trimmedName]) {
    return abbrevMap[locale][trimmedName]
  }
  if (abbrevMap[trimmedName]) {
    return abbrevMap[trimmedName]
  }
  return trimmedName
}

export const texts = {
  de: {
    billions: 'Mrd.',
    asOf: 'Stand',
    source: 'Quelle: BSW, frontmark',
    sourceBoersenumsaetze: 'Quelle: Börse Stuttgart',
    total: 'Gesamt',
    barChartYAxisTitle: 'Marktvolumen (in Mrd. €)',
    noData: 'Keine Daten vorhanden',
    months: 'Monate',
    download: downloadTexts.de
  },
  en: {
    billions: 'bn',
    asOf: 'As at',
    source: 'Source: BSW, frontmark',
    sourceBoersenumsaetze: 'Source: Börse Stuttgart',
    total: 'Total',
    barChartYAxisTitle: 'Market volume (in € bn)',
    noData: 'No data available',
    months: 'Months',
    download: downloadTexts.en
  }
}

export const barChartSeparators = {
  de: {
    thousands: '.',
    decimal: ','
  },
  en: {
    thousands: ',',
    decimal: '.'
  }
}
